
window.addEventListener("load", function () {
    // change background khi click quay 10
    $(".burgerNav").on("click", function () {
      $(".nav-top").toggleClass("active");
    });
    
    // Remove active class from floatnav when clicking menu items
    $(".nav-top--item").on("click", function () {
      $(".floatnav").removeClass("active");
    });
});
